import * as React from "react";
import type { SVGProps } from "react";
export const SvgYearInReviewPenta = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 24 24" {...props}>
    <g clipPath="url(#year-in-review-penta_svg__a)">
      <path fill="currentColor" d="m11.933 3.347 8.928 6.486-3.41 10.494H6.416L3.006 9.833l8.927-6.486Z" />
    </g>
    <defs>
      <clipPath id="year-in-review-penta_svg__a">
        <path fill="#fff" d="M2.4 3.2h19.067v17.6H2.4z" />
      </clipPath>
    </defs>
  </svg>
);
